import { Box, styled } from '@mui/material';

export const FlexBox = styled(Box)({
  flex: 1,
  display: 'flex',
});
